import React, { useEffect, useState, useReducer, useContext, useRef } from "react";
import { useLocation, useHistory } from 'react-router-dom';
import Select from 'react-select';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { CardPendenciaDeAprovacaoOptions } from "../../../components/CardPendenciaDeAprovacaoOptions";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { IconRefresh } from "../../../svg";
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { ToggleSwitchFilters } from "../../../components/ToggleSwitchFilters";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { Footer } from "../../../components/Footer";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { set, useForm } from 'react-hook-form';
import { PaginationCustom } from "../../../components/PaginationCustom";
import api from '../../../services/api';
import { Multiselect } from 'multiselect-react-dropdown';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { getSinisterStatus, getSinisterPort, getSinisterTypes } from '../../../services/sinistro';
import { getStatusList } from '../../../services/status';
import { getClients } from '../../../services/clientes';
import { getPeritos } from '../../../services/peritos';
import { getDisciplinas } from '../../../services/disciplinas';
import { getWorkflow } from '../../../services/workflow';
import { getOptionAllAprovacoes } from '../../../services/aprovacoes';
import { ModalAprovacoesAprovar } from "../../../components/ModalAprovacoesAprovar";
import { ModalAprovacaoEmMassa } from "../../../components/ModalAprovacaoEmMassa";
import { ModalAprovacoesReprovar } from "../../../components/ModalAprovacoesReprovar";
import { ModalAprovacoesCancelar } from "../../../components/ModalAprovacoesCancelar";
import { ModalAprovacoesTransferir } from "../../../components/ModalAprovacoesTransferir";
import { ModalAprovacoesConcluir } from "../../../components/ModalAprovacoesConcluir";
import { ModalNotificacaoAprovacaoHistorico } from "../../../components/ModalNotificacaoAprovacaoHistorico";
import { ModalObservacao } from "../../../components/ModalObservacao";
import { ModalSolicitarEsclarecimento } from "../../../components/ModalSolicitarEsclarecimento";
import { ModalTimeline } from "../../../components/ModalTimeline";
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import { TableAprovacoes } from "../../../components/TableAprovacoes";
import { TableAprovacoesPI } from "../../../components/TableAprovacoesPI";
import Swal from "sweetalert2";

let controllerAP;
const requestGet = async (params) => {

    if (controllerAP) {
        controllerAP.abort();
    }

    controllerAP = new AbortController();
    const signal = controllerAP.signal;

    let list = null;
    try {
        const response = await api.get(`Aprovacoes/list?${params}`, { signal });
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const getQueryParams = (query) => {
    const params = {};
    for (let [key, value] of query.entries()) {
        if (params[key]) {
            params[key] = [].concat(params[key], value);
        } else {
            params[key] = value;
        }
    }
    return params;
}

export const Aprovacoes = () => {
    const [showAdvanceSearch, setAdvanceSearch] = useState(false);
    var [showTableView, setShowTableView] = useState(false);
    var [legendaTableView, setLegendaTableView] = useState("Tabelas");
    const [defaultSetted, setDefaultSetted] = useState(null);
    var [minhasAprovacoes, setMinhasAprovacoes] = useState(false);
    var [minhasAprovacoesPI, setMinhasAprovacoesPI] = useState(false);
    var [checkAllAprovacoesPermission, setCheckAllAprovacoesPermission] = useState(false);
    var [checkAllAprovacoesPermissionPI, setCheckAllAprovacoesPermissionPI] = useState(false);
    const [ListaData, setListaData] = useState(null);
    const [filtersCount, setFiltersCount] = useState([]);
    const [filtersCountSub, setFiltersCountSub] = useState([]);
    var [isNotificados, setIsNotificados] = useState(false);
    var [isReprovados, setIsReprovados] = useState(false);
    var [isEsclarecimento, setIsEsclarecimento] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const { register, handleSubmit, reset, setValue } = useForm();
    const [disciplinaList, setDisciplinaList] = useState([]);
    const [disciplinaDefaultValue, setDisciplinaDefaultValue] = useState([]);
    const [workflowList, setWorkflowList] = useState([]);
    const [workflowListDefault, setWorkflowListDefault] = useState([]);
    const [peritosList, setPeritosList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [sinisterType, setSinisterType] = useState([]);
    const [sinisterPort, setSinisterPort] = useState([]);
    const [sinisterStatus, setSinisterStatus] = useState([]);
    const [pageSize, setPageSize] = useState(300);
    var [loadingData, setLoadingData] = useState(false);
    var [reguladora, setReguladora] = useState(null);
    var [idReguladora, setIdReguladora] = useState(null);
    var [idCorretora, setIdCorretora] = useState(null);
    // var [disciplina, setDisciplina] = useState(null);
    var [idDisciplinas, setDisciplinasId] = useState([]);
    var [idWorkflow, setWorkflowId] = useState([]);
    var [workflow, setWorkflow] = useState(null);
    var [idStatus, setStatusId] = useState([]);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    var [idEmpresaIndexTab, setIdEmpresaIndexTab] = useState(0);
    var [idEmpresa, setIdEmpresa] = useState(null);
    var [porteSinistro, setPorteSinistro] = useState(null);
    var [idPorteSinistro, setIdPorteSinistro] = useState(null);
    var [order, setOrder] = useState({});
    var [status, setStatus] = useState(null);
    var [statusPI, setStatusPI] = useState(null);
    var [tipoSinistro, setTipoSinistro] = useState(null);
    var [idTipoSinistro, setIdTipoSinistro] = useState(null);
    var [searchReadOnly, setSearchReadOnly] = useState(false);
    var [idSlaList, setSlaList] = useState([]);
    var [empresasUser, setEmpresasUser] = useState([]);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const multiselectRef = useRef();
    const multiselectRefWorkflow = useRef();
    const orderRef = useRef();
    var [tiposDeOrdenacao, setTiposDeOrdenacao] = useState([]);
    const [modalAprovarIsOpen, setModalAprovarIsOpen] = useState(false);
    const [modalReprovarIsOpen, setModalReprovarIsOpen] = useState(false);
    const [modalCancelarIsOpen, setModalCancelarIsOpen] = useState(false);
    const [modalTransferirIsOpen, setModalTransferirIsOpen] = useState(false);
    const [pendenciaDeAprovacao, setPendenciaDeAprovacao] = useState(false);
    const [modalConcluirIsOpen, setModalConcluirIsOpen] = useState(false);
    const [selectedIdTimesheet, setSelectedIdTimesheet] = useState(null);
    const [modalSolicitarEsclarecimentoIsOpen, setModalSolicitarEsclarecimentoIsOpen] = useState(false);
    const [modalObservacoes, setmodalObservacoes] = useState(false);

    var [searchInput, setSearchInput] = useState(null);

    const history = useHistory();
    const query = useQuery();
    const queryParams = getQueryParams(query);


    const advanceSearch = { name: 'advanceSeach', label: 'Pesquisa Avançada', id: 'advanceSeachAP', status: showAdvanceSearch };
    const advanceAprovacao = { name: 'advanceAprovacao', label: 'Todas Aprovações T.S', id: 'advanceAprovacaoAP', status: minhasAprovacoes, checked: minhasAprovacoes };
    const advanceAprovacaoPI = { name: 'advanceAprovacaoPI', label: 'Todas Aprovações P.I', id: 'advanceAprovacaoAPPI', status: minhasAprovacoesPI, checked: minhasAprovacoesPI };
    const advanceShowTableView = { name: 'showTableView', label: legendaTableView, id: 'idApshowTableView', status: showTableView };


    const getLista = async (formValues = null, currentPage = 0, pageSize) => {

        let params = `Start=${currentPage}&Length=${pageSize ?? 300}`;

        params += `&MinhasAprovacoes=${!formValues.minhasAprovacoes}`;
        params += `&MinhasAprovacoesPI=${formValues.minhasAprovacoesPI}`;
        params += `&IdEmpresa=${formValues.idEmpresa}`;

        if (formValues?.search && formValues?.search?.length > 0) {
            params += `&Pesquisa=${formValues.search}`;
        }

        if (formValues.data?.Segurado?.length > 0) {
            params += `&Segurado=${formValues.data.Segurado}`;
        }

        if (formValues.data?.Sigla?.length > 0) {
            params += `&Sigla=${formValues.data.Sigla}`;
        }

        if (formValues.data?.NumeroTimesheet?.length > 0) {
            params += `&NumeroTimesheet=${formValues.data.NumeroTimesheet}`;
        }

        if (formValues.idDisciplinas?.length > 0) {
            formValues.idDisciplinas.forEach(disciplina => {
                params += `&Disciplinas=${disciplina}`;
            });
        }

        if (formValues?.idWorkflow?.length > 0) {
            formValues?.idWorkflow.forEach(step => {
                params += `&Steps=${step}`;
            });
        }

        if (formValues.idSlaList?.length > 0) {
            formValues.idSlaList.forEach(sla => {
                params += `&SLA=${sla}`;
            });
        }

        if (formValues.idCliente > 0) {
            params += `&IdCliente=${formValues.idCliente}`;
        }

        if (formValues.idReguladora > 0) {
            params += `&IdReguladora=${formValues.idReguladora}`;
        }

        if (formValues.idCorretora > 0) {
            params += `&IdCorretora=${formValues.idCorretora}`;
        }

        if (formValues.idTipoSinistro > 0) {
            params += `&IdTipoSinistro=${formValues.idTipoSinistro}`;
        }

        if (formValues.idPorteSinistro > 0) {
            params += `&IdPorteSinistro=${formValues.idPorteSinistro}`;
        }

        if (formValues.idStatus > 0) {
            params += `&Status=${formValues.idStatus}`;
        }

        if (formValues.startDate) {
            params += `&PeriodoInicial=${moment(formValues.startDate).format('YYYY-MM-DD')}`;
        }

        if (formValues.endDate) {
            params += `&PeriodoFinal=${moment(formValues.endDate).format('YYYY-MM-DD')}`;
        }

        if (formValues.Order != null) {
            params += `&Order=${formValues.Order}`;
        }


        if (formValues.isNotificados) {
            params += `&Notificados=true`;
        }

        if (formValues.isReprovados) {
            params += `&Reprovados=true`;
        }

        if (formValues.isEsclarecimento) {
            params += `&Esclarecimento=true`;
        }

        history.replace(`aprovacoes?${params}&showAdvanceSearch=${showAdvanceSearch}`);

        setLoadingData(true);

        const rstData = await requestGet(params);

        setLoadingData(false);

        return rstData;
    }

    const formSubmit = async (data, meusTimesheetsParam = false) => {
        loadTable(data, 0, 300, meusTimesheetsParam);
    }

    const loadTable = async (data, currentPage, pageSize, meusTimesheetsParam = false) => {
        let Order = null;
        if (order != null) {
            Order = order.value
        }

        let formValues = {
            minhasAprovacoes: minhasAprovacoes,
            minhasAprovacoesPI: minhasAprovacoesPI,
            data: data,
            search: (searchInput?.length >= 3) ? searchInput : null,
            idDisciplinas: idDisciplinas,
            idWorkflow: idWorkflow,
            idCliente: idCliente,
            idEmpresa: idEmpresa,
            idReguladora: idReguladora,
            idCorretora: idCorretora,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idStatus: idStatus,
            idSlaList: idSlaList,
            startDate: startDate,
            endDate: endDate,
            Order: Order,
            isNotificados: isNotificados,
            isReprovados: isReprovados,
            isEsclarecimento: isEsclarecimento
        };

        setListaData(null);
        const lista = await getLista(formValues, currentPage, pageSize);

        setListaData(lista);
        if (lista != null && lista?.data?.itens?.length > 0) {
            pageSize = lista.data.page.recordsPaging;
            setFiltersCount(lista.data.page.filterCounts);
            setFiltersCountSub(lista.data.page.filterCountsSub);
        }
        if (lista != null && lista.data != null && lista.data.access != null) {
            setAprovacaoEmMassa(lista.data.access.aprovacaoEmMassa);
        }
    }

    const getStatusToggle = (status) => {
        setAdvanceSearch(status);
        setSearchReadOnly(status);
        searchReadOnly = status;
    };

    const getMinhasAprovacoes = (status) => {
        minhasAprovacoes = status;
        setMinhasAprovacoes(status);
        setTimeout(() => {
            formSubmit(null, status);
        }, 500);
    };

    const getMinhasAprovacoesProjetosInternos = (status) => {
        setAprovacaoEmMassaList([]);
        minhasAprovacoesPI = status;
        setMinhasAprovacoesPI(status);
        setTimeout(() => {
            formSubmit(null, status);
        }, 500);
    };

    const getShowTableView = (status) => {
        showTableView = status;
        setShowTableView(status);
        legendaTableView = !status ? 'Tabela' : 'Cards';
        setLegendaTableView(legendaTableView);
    };

    const onGetDisciplina = (currentValue, value) => {
        let disciplinasList = [];
        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        setDisciplinasId(disciplinasList);
    };

    const onRemoveDisciplina = (currentValue, value) => {
        onGetDisciplina(currentValue, "")
    }

    const onGetWorkflow = (currentValue, value) => {

        let workflowListP = [];

        if (currentValue?.length > 0) {
            currentValue.map(a => {
                a.idsSteps.map(b => { workflowListP.push(b) });
            });

            idWorkflow = workflowListP;

            setWorkflowId(workflowListP);
        }
    };

    const onRemoveWorkflow = (currentValue, value) => {
        let workflowListP = [];

        if (currentValue?.length > 0) {
            currentValue.map(a => {
                a.idsSteps.map(b => { workflowListP.push(b) });
            });

            idWorkflow = workflowListP;

            console.log(workflowListP);
            setWorkflowId(workflowListP);
        }
    }

    const getSearch = async (currentValue, value, pageSize, forceidEmpresa = false) => {
        searchInput = (currentValue?.length >= 3) ? currentValue : null;
        setSearchInput(searchInput);

        let data = {
            IdentificaoSolicitacao: null,
            Segurado: null,
            Contato: null,
            Endereco: null
        }

        let formValues = {
            data: data,
            minhasAprovacoes: minhasAprovacoes,
            minhasAprovacoesPI: minhasAprovacoesPI,
            search: (currentValue?.length >= 3) ? currentValue : null,
            idDisciplinas: null,
            idCliente: null,
            idEmpresa: forceidEmpresa != false ? forceidEmpresa : idEmpresa,
            idReguladora: null,
            idCorretora: null,
            idTipoSinistro: null,
            idPorteSinistro: null,
            idWorkflow: null,
            idStatus: null,
            idSlaList: idSlaList,
            startDate: null,
            endDate: null,
            isNotificados: isNotificados,
            isReprovados: isReprovados,
            isEsclarecimento: isEsclarecimento
        };

        setPageSize(pageSize);

        const listaData = await getLista(formValues, currentPage, pageSize);
        setListaData(null);

        if (listaData?.data?.itens?.length > 0) {
            setListaData(listaData);
            pageSize = listaData.length;
        }

        setFiltersCount(listaData?.data?.page?.filterCounts);
        setFiltersCountSub(listaData?.data?.page?.filterCountsSub);

    };

    const refreshData = async () => {
        let Order = null;
        if (order != null) {
            Order = order.value
        }

        let data = {
            IdentificaoSolicitacao: null,
            Segurado: null,
            NumeroTimesheet: null,
            Sigla: null,
        }

        let formValues = {
            data: data,
            minhasAprovacoes: minhasAprovacoes,
            minhasAprovacoesPI: minhasAprovacoesPI,
            search: (searchInput?.length >= 3) ? searchInput : '',
            idDisciplinas: idDisciplinas,
            idWorkflow: idWorkflow,
            idCliente: idCliente,
            idEmpresa: idEmpresa,
            idReguladora: idReguladora,
            idCorretora: idCorretora,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idStatus: idStatus,
            idSlaList: idSlaList,
            startDate: startDate,
            endDate: endDate,
            Order: Order
        };

        setPageSize(pageSize);
        setListaData(null);
        try {

            const listaData = await getLista(formValues, currentPage, pageSize);
            setListaData(listaData);
            pageSize = listaData.length;
            setFiltersCount(listaData.data.page.filterCounts);
            setFiltersCountSub(listaData.data.page.filterCountsSub);

        } catch (error) {
            console.log(error);
        }

    }

    const getCliente = (currentValue, value) => {

        if (value === "clear" || value === null) {
            setCliente(null);
            setIdCliente(null);
            return;
        }

        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });


        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);


    };

    const getPorteSinistro = (currentValue, value) => {

        if (value === "clear" || value === null) {
            setPorteSinistro(null);
            setIdPorteSinistro(null);
            return;
        }

        var porteSinistroResult = sinisterPort.filter(function (o) {
            return o.key == value;
        });

        porteSinistro = porteSinistroResult[0].value;
        idPorteSinistro = porteSinistroResult[0].key;
        setPorteSinistro(porteSinistro);
        setIdPorteSinistro(idPorteSinistro);

    };

    const getTipoSinistro = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setTipoSinistro(null);
            setIdTipoSinistro(null);
            return;
        }


        var tipoSinistroResult = sinisterType.filter(function (o) {
            return o.idTipoSinistro == value;
        });

        tipoSinistro = tipoSinistroResult[0].nome;
        idTipoSinistro = tipoSinistroResult[0].idTipoSinistro;
        setTipoSinistro(tipoSinistro);
        setIdTipoSinistro(idTipoSinistro);

    };

    const getStatus = (currentValue, value) => {

        if (value === "clear" || value === null) {
            setStatus(null);
            setStatusId(null);
            return;
        }

        var statusResult = statusList.filter(function (o) {
            return o.key == value;
        });

        status = statusResult[0].value;
        idStatus = statusResult[0].key;
        setStatus(status);
        setStatusId(idStatus);

    };

    const getCardId = (id) => {
        let cardId = document.getElementById(id);

        if (cardId.getAttribute('class', 'card-menu-hide') === 'card-menu-hide') {
            cardId.removeAttribute('class', 'card-menu-hide');
            cardId.setAttribute('class', 'card-menu-show');
        }
        else {
            cardId.removeAttribute('class', 'card-menu-show');
            cardId.setAttribute('class', 'card-menu-hide');
        }
    };

    const filterForm = (filtro) => {
        setOrder(filtro)
    }

    const formatToDate = (date) => {

        if (!date) {
            return null;
        }
        return moment(date).toDate();
    }

    useEffect(() => {
        setTiposDeOrdenacao([
            {
                id: "Valor Total(Crescente)",
                label: "Valor Total(Crescente)",
                value: "timesheet.ValorTotalFaturado asc"
            },
            {
                id: "Valor Total(Decrescente)",
                label: "Valor Total(Decrescente)",
                value: "timesheet.ValorTotalFaturado desc"
            },
            {
                id: "Data Prazo(Crescente)",
                label: "Data Prazo(Crescente)",
                value: "pendenciaAprovacao.DataPrazo asc"
            },
            {
                id: "Data Prazo(Decrescente)",
                label: "Data Prazo(Decrescente)",
                value: "pendenciaAprovacao.DataPrazo desc"
            },
            {
                id: "Data de Criação do TS(Crescente)",
                label: "Data de Criação do TS(Crescente)",
                value: "timesheet.Datacriacao asc"
            },
            {
                id: "Data de Criação do TS(Decrescente)",
                label: "Data de Criação do TS(Decrescente)",
                value: "timesheet.Datacriacao desc"
            },
            {
                id: "Cliente(Crescente)",
                label: "Cliente(Crescente)",
                value: "cliente.Cliente asc"
            },
            {
                id: "Cliente(Decrescente)",
                label: "Cliente(Decrescente)",
                value: "cliente.Cliente desc"
            }
        ])

        Promise.all([
            getDisciplinas(),
            getPeritos(),
            getClients(),
            getSinisterPort(21),
            getSinisterTypes(20),
            getSinisterStatus(2),
            getStatusList(44),
            getWorkflow(),
            getOptionAllAprovacoes()
        ]).then((dataResponse) => {

            setDisciplinaList(dataResponse[0]);
            setPeritosList(dataResponse[1]);
            setClientList(dataResponse[2]);
            setSinisterPort(dataResponse[3]);
            setSinisterType(dataResponse[4]);
            setSinisterStatus(dataResponse[5]);
            setStatusList(dataResponse[6]);

            setDefaultFiltersDisciplina(dataResponse[0], queryParams?.Disciplinas);
            setDefaultFiltersStatus(dataResponse[6], queryParams?.Status);
            setDefaultFiltersCliente(dataResponse[2], queryParams?.IdCliente);
            checkIsMultEmpresaUser();
            setDefaultFiltersEmpresa(queryParams?.IdEmpresa);
            setDefaultFiltersPorte(dataResponse[3], queryParams?.IdPorteSinistro);
            setDefaultFiltersTipoSinistro(dataResponse[4], queryParams?.IdTipoSinistro);

            queryParams.MinhasAprovacoes = dataResponse[8] ? 'false' : 'true';
            setCheckAllAprovacoesPermission(dataResponse[8]);

            queryParams.MinhasAprovacoesPI = dataResponse[9] ? 'false' : 'true';
            setCheckAllAprovacoesPermissionPI(dataResponse[9]);

            const rstWorkflowList = agruparEmNovoAtributo(dataResponse[7], 'step', 'idsSteps');
            setWorkflowList(rstWorkflowList);

            setDefaultFiltersEtapaAp(rstWorkflowList, queryParams?.Steps);



            setDefaultFilters();
        });
    }, []);

    const checkIsMultEmpresaUser = (value) => {
        const empresas = localStorage.getItem('empresasUsuario') ?
            JSON.parse(localStorage.getItem('empresasUsuario'))
            : [];

        if (empresas) {
            empresasUser = empresas;
            setEmpresasUser(empresasUser);
        }

        if (empresasUser.length > 1) {
            setIdEmpresa(1);
            setIdEmpresaIndexTab(0);
        }
        else {
            setIdEmpresa(empresas[0]);
        }
    }

    const agruparEmNovoAtributo = (lista, propriedade, novoAtributo) => {
        const agrupado = {};
        lista.forEach(item => {
            const chave = item[propriedade];

            if (!agrupado[chave]) {
                agrupado[chave] = {
                    ...item,
                    [novoAtributo]: []
                };
            }

            agrupado[chave][novoAtributo].push(item.idStep);
        });

        return Object.values(agrupado);
    }

    const setDefaultFiltersCliente = (itensList, itenFiltered) => {


        if (itenFiltered && itensList.length > 0) {

            var clienteResult = itensList.find((o) => o.idCliente === parseInt(itenFiltered, 10));
            cliente = clienteResult?.cliente ?? null;
            idCliente = clienteResult?.idCliente ?? null;
            setCliente(cliente);
            setIdCliente(idCliente);
        }
    }

    const setDefaultFiltersEmpresa = (itenFiltered) => {
        if (itenFiltered) {
            idEmpresa = itenFiltered;
            setIdEmpresa(idEmpresa);

            switch (itenFiltered) {
                case '0':
                case 0:
                    setIdEmpresaIndexTab(2);
                    break;
                case '1':
                case 1:
                    setIdEmpresaIndexTab(0);
                    break;
                case '2':
                case 2:
                    setIdEmpresaIndexTab(1);
                    break;
                default:
                    setIdEmpresaIndexTab(2);
                    break;
            }
        }
    }

    const setDefaultFiltersStatus = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {

            var statusResult = itensList.find((o) => o.key === parseInt(itenFiltered, 10));
            status = statusResult?.value ?? null;
            idStatus = statusResult?.key ?? null;
            setStatus(status);
            setStatusId(idStatus);
        }
    }

    const setDefaultFiltersPorte = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {

            var porteSinistroResult = itensList.find((o) => o.key === parseInt(itenFiltered, 10));
            porteSinistro = porteSinistroResult?.value ?? null;
            idPorteSinistro = porteSinistroResult?.key ?? null;
            setPorteSinistro(porteSinistro);
            setIdPorteSinistro(idPorteSinistro);
        }
    }

    const setDefaultFiltersTipoSinistro = (itensList, itenFiltered) => {

        if (itenFiltered && itensList.length > 0) {

            var tipoSinistroResult = itensList.find((o) => o.key === parseInt(itenFiltered, 10));
            tipoSinistro = tipoSinistroResult?.value ?? null;
            idTipoSinistro = tipoSinistroResult?.key ?? null;
            setTipoSinistro(tipoSinistro);
            setIdTipoSinistro(idTipoSinistro);
            queryParams.showAdvanceSearch = 'true'
        }
    }

    const setDefaultFiltersDisciplina = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {
            const ids = itenFiltered?.length > 0 && typeof itenFiltered != 'string' ? itenFiltered.map(item => parseInt(item, 10)) : [parseInt(itenFiltered, 10)];
            const disciplinasList = itensList.filter(item => ids.includes(item.idDisciplina));
            setDisciplinasId(ids);
            setDisciplinaDefaultValue(disciplinasList);
            queryParams.showAdvanceSearch = 'true'

        }
    }

    const setDefaultFiltersEtapaAp = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {
            const ids = itenFiltered?.length > 0 && typeof itenFiltered != 'string' ? itenFiltered : [itenFiltered];
            const workflowSelected = itensList.filter(item => ids.includes(item.idStep));

            setWorkflowListDefault(workflowSelected);
            onGetWorkflow(workflowSelected, ids);
            queryParams.showAdvanceSearch = 'true'
        }
    }

    const setDefaultFilters = () => {
        let data = {
            Segurado: (queryParams?.Segurado?.length >= 3) ? queryParams.Segurado : null,
            NumeroTimesheet: (queryParams?.NumeroTimesheet?.length >= 3) ? queryParams.NumeroTimesheet : null,
            Sigla: (queryParams?.Sigla?.length >= 3) ? queryParams.Sigla : null,
        }

        setValue('Segurado', (queryParams?.Segurado?.length >= 3) ? queryParams.Segurado : null);
        setValue('NumeroTimesheet', (queryParams?.NumeroTimesheet?.length >= 3) ? queryParams.NumeroTimesheet : null);
        setValue('Sigla', (queryParams?.Sigla?.length >= 3) ? queryParams.Sigla : null);

        const chck = queryParams.MinhasAprovacoes === 'false' ? true : false;
        minhasAprovacoes = chck;
        setMinhasAprovacoes(chck);

        const chckPI = queryParams.MinhasAprovacoesPI === 'false' ? true : false;
        minhasAprovacoesPI = chckPI;
        setMinhasAprovacoesPI(chckPI);

        setAdvanceSearch(queryParams?.showAdvanceSearch === 'true' ? true : false);

        searchInput = (queryParams?.Pesquisa?.length >= 3) ? queryParams?.Pesquisa : null;
        setSearchInput(searchInput);

        setStartDate(formatToDate(queryParams?.PeriodoInicial));
        setEndtDate(formatToDate(queryParams?.PeriodoFinal));

        if (queryParams?.SLA) {
            const ids = queryParams?.SLA?.length > 0 && typeof queryParams?.SLA != 'string' ? queryParams?.SLA.map(item => parseInt(item, 10)) : [parseInt(queryParams?.SLA, 10)];
            setSlaList(ids);
        }

        isNotificados = queryParams?.Notificados === 'true' ? true : false;
        setIsNotificados(isNotificados);

        setDefaultSetted(data)
    }

    // Após setar todos os filtros é necessário usar o useeffect em uma variável diferente para que as alterçaões de state sejam refletidas
    useEffect(() => {
        if(defaultSetted)
            loadTable(defaultSetted, 0, 300);
    }, [defaultSetted])

    const openModalAprovar = (item) => {
        setPendenciaDeAprovacao(item)
        setModalAprovarIsOpen(true);
    };

    const closeModalAprovar = () => {
        setModalAprovarIsOpen(false);
    }

    const openModalReprovar = (item) => {
        setPendenciaDeAprovacao(item)
        setModalReprovarIsOpen(true);
    };

    const closeModalReprovar = () => {
        setModalReprovarIsOpen(false);
    }

    const openModalCancelar = (item) => {
        setPendenciaDeAprovacao(item)
        setModalCancelarIsOpen(true);
    };

    const closeModalCancelar = () => {
        setModalCancelarIsOpen(false);
    }

    const openModalTransferir = (item) => {
        setPendenciaDeAprovacao(item)
        setModalTransferirIsOpen(true);
    };

    const closeModalTransferir = () => {
        setModalTransferirIsOpen(false);
    }

    const openModalConcluir = (item) => {
        setPendenciaDeAprovacao(item)
        setModalConcluirIsOpen(true);
    };

    const closeModalConcluir = () => {
        setModalConcluirIsOpen(false);
    }

    const submitButtonRef = useRef(null)

    const [startDate, setStartDate] = useState(null);
    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const [endDate, setEndtDate] = useState(null);
    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }

    const limparPesquisa = () => {

        history.replace(`timesheet?timesheet?Start=0&Length=300&meuTimeSheet=true&showAdvanceSearch=true`);


        setValue('Segurado', '');
        setValue('NumeroTimesheet', '');
        setValue('Sigla', '');
        setValue('EnderecoSinistro', '');

        reset({
            IdentificaoSolicitacao: '',
            Segurado: '',
            Contato: '',
            Endereco: ''
        });
        setCliente(null);
        setReguladora(null);
        setTipoSinistro(null);
        setPorteSinistro(null);
        setStatus(null);


        workflow = null;
        idWorkflow = null;
        setWorkflowId(null);
        setWorkflowListDefault(null);

        setStartDate(null);
        setEndtDate(null);

        setSearchInput(null);
        setIsNotificados(false);
        setIsEsclarecimento(false);


        multiselectRef.current.resetSelectedValues();
        multiselectRefWorkflow.current.resetSelectedValues();
    }

    const [modalHistoricoAprovacoesIsOpen, setModalHistoricoAprovacoesIsOpen] = useState(false);
    const closeNotifyHistoricoModal = () => {
        setModalHistoricoAprovacoesIsOpen(false);
    }

    const openHistoricoAprovacoesModal = async (item) => {
        setModalHistoricoAprovacoesIsOpen(true);
        setPendenciaDeAprovacao(item);
    };

    const addListSLA = (sla) => {
        idSlaList.push(sla);
        setSlaList(idSlaList);
    }

    const removeListSLA = (sla) => {
        idSlaList = idSlaList.filter(item => item !== sla);
        setSlaList(idSlaList);
    }

    // set Tipo notificado ou reprovado
    const setTipoNotOuRepFiltro = (event, id) => {

        if (id === 'Notificado') {
            isNotificados = event.target.checked;
            setIsNotificados(isNotificados);
        }

        if (id === 'Reprovado') {
            isReprovados = event.target.checked;
            setIsReprovados(isReprovados);
        }

        if (id === 'Esclarecimento') {
            isEsclarecimento = event.target.checked;
            setIsEsclarecimento(isEsclarecimento);
        }

    }

    const handleOnChangeFilter = (event, id, tipo = false) => {
        if (!tipo) {
            (event.target.checked) ? addListSLA(id) : removeListSLA(id);
        } else {
            setTipoNotOuRepFiltro(event, id)
        }
        getSearch(null, null, 300);
    }

    const filtroEmpresa = (indexTab) => {
        setIdEmpresaIndexTab(indexTab)
        var empresa = 0
        switch (indexTab) {
            case 0:
                empresa = 1;
                break;
            case 1:
                empresa = 2;
                break;
            case 2:
                empresa = -1;
                break;
            default:
                empresa = -1;
                break;
        }

        setIdEmpresa(empresa);
        getSearch(searchInput, null, 300, empresa);
    }

    const openObservacoesTimesheet = (idTimesheet) => {
        setSelectedIdTimesheet(idTimesheet)
        openModalObservacoesOpen()
    }

    const openModalObservacoesOpen = () => {
        setmodalObservacoes(true);
    };

    const closeModalObservacoes = () => {
        setmodalObservacoes(false);
    }

    const afterNotifyGrupoOpenModal = () => { };

    const openModalASolicitarEsclarecimento = (item) => {
        setPendenciaDeAprovacao(item)
        setModalSolicitarEsclarecimentoIsOpen(true);
    };

    const closeModalSolicitarEsclarecimento = () => {
        setModalSolicitarEsclarecimentoIsOpen(false);
    }

    const [modalTimelineIsOpen, setmodalTimelineIsOpen] = useState(false);
    const [selectedTimesheet, setSelectedTimesheet] = useState(null);
    const openModalTimesheetTimeline = (timesheet) => {
        setSelectedTimesheet(timesheet)
        setmodalTimelineIsOpen(true)
    }

    // Contexto de aprovação em massa
    const [aprovacaoEmMassa, setAprovacaoEmMassa] = useState(false);
    const [aprovacaoEmMassaList, setAprovacaoEmMassaList] = useState([]);
    const [aprovacaoEmMassaOpemModal, setAprovacaoEmMassaOpemModal] = useState(false);

    const openModalAprovacaoEmMassa = () => {
        if(!aprovacaoEmMassaList || aprovacaoEmMassaList.length === 0) {
            Swal.fire({
                title: "Atenção",
                text: "Antes de continuar, selecione as atividades que deseja aprovar.",
                icon: "error",
                confirmButtonText: "OK",
            });
            return
        }

        setAprovacaoEmMassaOpemModal(true);
    }

    const closeModalAprovacaoEmMassa = () => {
        setAprovacaoEmMassaOpemModal(false);
    }

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>

                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header m-0">Aprovações</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>

                    <div className="card">
                        <div className="row">
                            <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-2">
                                <ToggleSwitchFilters config={advanceAprovacao} setStatus={(status) => getMinhasAprovacoes(status)} />
                            </div>
                            <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-2">
                                <ToggleSwitchFilters config={advanceAprovacaoPI} setStatus={(status) => getMinhasAprovacoesProjetosInternos(status)} />
                            </div>
                            <div className="col-sm-12 col-md-3 col-lg-3 col-xxl-3 my-1-mobile">
                                <DynamicInput placeholder={''} componentReadOnly={searchReadOnly} label={'Pesquisar'} name={'Search'} paramMethod={getSearch} value={searchInput} />
                            </div>
                            <div className="d-flex flex-column justify-content-center justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-2">
                                <ToggleSwitchFilters config={advanceSearch} setStatus={(status) => getStatusToggle(status)} />
                            </div>

                            <div className="col-sm-12 col-md-3 col-lg-3 col-xxl-2 mt-1-mobile">
                                <Select
                                    ref={orderRef}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            height: '48px',
                                            width: '100%',
                                        }),
                                    }}
                                    isClearable={true}
                                    className="basic-single"
                                    placeholder={'Ordernar'}
                                    options={tiposDeOrdenacao}
                                    onChange={filterForm}
                                />
                            </div>
                        </div>

                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            <div className={!!showAdvanceSearch ? `form-wrapper filter-container mt-3` : `form-wrapper filter-container filter-hide`}>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº Timesheet'} name={'NumeroTimesheet'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Sigla'} name={'Sigla'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2 header-select">
                                    <DynamicSelect placeholder={''} valuetext={porteSinistro} label={'Porte Sinistro'} name={'idPorteSinistro'} options={sinisterPort} keyValue={'key'} keyLabel={'value'} paramMethod={getPorteSinistro} clearOption={true} />

                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Selecione a disciplina'}
                                        showCheckbox="true"
                                        options={disciplinaList} // Options to display in the dropdown
                                        selectedValues={disciplinaDefaultValue} // Preselected value to persist in dropdown
                                        onSelect={onGetDisciplina} // Function will trigger on select event
                                        onRemove={onRemoveDisciplina} // Function will trigger on remove event
                                        displayValue="titulo" // Property name to display in the dropdown options
                                        ref={multiselectRef}
                                        showArrow={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Etapa Aprovação'}
                                        showCheckbox="true"
                                        options={workflowList} // Options to display in the dropdown
                                        selectedValues={workflowListDefault} // Preselected value to persist in dropdown
                                        onSelect={onGetWorkflow} // Function will trigger on select event
                                        onRemove={onRemoveWorkflow} // Function will trigger on remove event
                                        displayValue="step" // Property name to display in the dropdown options
                                        ref={multiselectRefWorkflow}
                                        showArrow={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-sm-12 col-md-3 col-lg-3 p-2 header-select">
                                    <DynamicSelect placeholder={''} valuetext={status} label={'Status'} name={'idAtividade'} options={statusList} keyValue={'key'} keyLabel={'value'} paramMethod={getStatus} clearOption={true} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2 header-select">
                                    <DynamicSelect placeholder={''} valuetext={tipoSinistro} label={'Tipo Sinistro'} name={'idTipoSinistro'} options={sinisterType} keyValue={'idTipoSinistro'} keyLabel={'nome'} paramMethod={getTipoSinistro} clearOption={true} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <DynamicSelect placeholder={''} valuetext={cliente} label={'Selecione o cliente'} name={'idCliente'} options={clientList} keyValue={'idCliente'} keyLabel={'cliente'} paramMethod={getCliente} clearOption={true} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 mt-2" style={{ float: 'left' }}>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form"
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        placeholderText={'Data de início'}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 mt-2" style={{ float: 'left' }}>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form"
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        placeholderText={'Data fim'}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 mt-2">
                                    <input className='default-button mr-3' value='Limpar' type="button" onClick={() => limparPesquisa()} />
                                    <input type="submit" className='default-button-red' value='Pesquisar' ref={submitButtonRef} />
                                </div>
                            </div>
                        </StyledForm>

                        <div className={isDesktop ? 'row justify-content-end my-2' : 'row justify-content-center my-2'} key={'filterCheckStatusListRow'}>
                            {isDesktop ?
                                <>
                                    <div className="col-xs-6 col-sm-8 col-md-4 col-lg-4 col-xl-3 " >
                                        <ToggleSwitch config={advanceShowTableView} setStatus={(status) => getShowTableView(status)} />
                                    </div>
                                    {/* <div className="col-xs-6 col-sm-8 col-md-4 col-lg-5 col-xl-5" ></div> */}
                                </>
                                : null}
                            {isDesktop ?
                                <>
                                    <div className="col-xs-6 col-sm-8 col-md-4 col-lg-5 col-xl-5" key={'filterTabs'}>
                                    <Tabs className="timesheet" selectedIndex={idEmpresaIndexTab} onSelect={(index) => filtroEmpresa(index)} focusTabOnClick={false}>
                                            <TabList>
                                                <Tab >Critério Experts</Tab>
                                                <Tab >Adjusters</Tab>
                                                <Tab >Todos</Tab>
                                            </TabList>
                                        </Tabs>
                                    </div>
                                </>
                                : null}
                            <div className={isDesktop ? 'col-xs-6 col-sm-8 col-md-4 col-lg-4 col-xl-4' : 'd-flex justify-content-center'} key={'filterCheckStatusListCol'}>
                                <div className={isDesktop ? 'btn-group btn-group-sm pull-right' : 'btn-group btn-group-sm'} role="group" key={'filterCheckStatusListGroup'}>
                                    {
                                        filtersCount?.map((item, index) => {
                                            return (
                                                <>
                                                    <input type="checkbox" name="filterCheckStatus" className="btn-check d-flex"
                                                        key={'CheckBox' + item.key} id={'CheckBox' + item.key}
                                                        value={item.key}
                                                        onChange={(event) => handleOnChangeFilter(event, item.key)}
                                                        checked={idSlaList?.includes(item.key)}
                                                    />
                                                    <label className="btn btn-sm btn-light mb-0 w-100" key={'CheckBoxLabel' + item.key} htmlFor={'CheckBox' + item.key}>
                                                        <span className="text-max-10"> {item.labelFullText}</span> <br /><i key={'CheckBoxLabelCount' + item.key} className={`fa fa-circle text-${item.label}`} aria-hidden="true"></i>
                                                    </label>
                                                </>
                                            )
                                        })
                                    }
                                    {
                                        isDesktop ? filtersCountSub?.map((item, index) => {
                                            if (item.key === 1 || item.key === 3) {
                                                return (
                                                    <>
                                                        <input type="checkbox" name="filterCheckStatus" className="btn-check d-flex"
                                                            key={'CheckBoxSub' + item.key} id={'CheckBoxSub' + item.key}
                                                            value={item.label}
                                                            onChange={(event) => handleOnChangeFilter(event, item.label, true)}
                                                            checked={(item.label === 'Notificado' && isNotificados) || (item.label === 'Esclarecimento' && isEsclarecimento)}
                                                        />
                                                        <label className="btn btn-sm btn-light mb-0 w-100" key={'CheckBoxSubLabel' + item.key} htmlFor={'CheckBoxSub' + item.key}>
                                                            <span className="text-max-10"> {item.labelFullText}</span> <br />
                                                            <span className={'badge bg-primary color-text-filter ' + ' filter-' + item.label} key={'CheckBoxSubLabelCount' + item.key} >{item.count}</span>
                                                        </label >

                                                    </>
                                                )
                                            }
                                        })
                                            : null}
                                </div>
                            </div>
                        </div>
                        {
                            !isDesktop ?

                                <div className="row mb-2 " key={'filterCheckStatusListRow'}>
                                    <div className="d-flex justify-content-center " key={'filterCheckStatusListCol'}>
                                        <div className="btn-group btn-group-sm" role="group" key={'filterCheckStatusListGroup'}>
                                            {filtersCountSub?.map((item, index) => {
                                                if (item.key === 1 || item.key === 3) {
                                                    return (
                                                        <>
                                                            <input type="checkbox" name="filterCheckStatus" className="btn-check d-flex"
                                                                key={'CheckBoxSub' + item.key} id={'CheckBoxSub' + item.key}
                                                                value={item.label}
                                                                onChange={(event) => handleOnChangeFilter(event, item.label, true)}
                                                                checked={isNotificados}
                                                            />
                                                            <label className="btn btn-sm btn-light mb-0 w-100" key={'CheckBoxSubLabel' + item.key} htmlFor={'CheckBoxSub' + item.key}>
                                                                <span className="text-max-10"> {item.labelFullText}</span> <br />
                                                                <span className={'badge bg-primary color-text-filter ' + ' filter-' + item.label} key={'CheckBoxSubLabelCount' + item.key} >{item.count}</span>
                                                            </label >

                                                        </>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>

                                : null}

                        {loadingData ?
                            <StldRow>
                                <div className="text-center">
                                    <div className="align-items-center">
                                        <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        <div><strong style={{ color: "#EE4B21" }}>{'Atualizando...'}</strong></div>
                                    </div>
                                </div>
                            </StldRow > :
                            ''}


                        {(() => {
                            if (isDesktop && !showTableView) {
                                return (
                                    minhasAprovacoesPI ?
                                    <StldRow>
                                        <TableAprovacoesPI listaAprovacoes={ListaData}
                                            aprovacaoEmMassa={aprovacaoEmMassa}
                                            clearCheckedList={minhasAprovacoesPI}
                                            setAprovacaoEmMassaList={setAprovacaoEmMassaList}
                                            openModalAprovacaoEmMassa={openModalAprovacaoEmMassa}
                                            openModalAprovar={openModalAprovar}
                                            openModalReprovar={openModalReprovar}
                                            openModalCancelar={openModalCancelar}
                                            openModalTransferir={openModalTransferir}
                                            openModalConcluir={openModalConcluir}
                                            openHistoricoAprovacoesModal={openHistoricoAprovacoesModal}
                                            openObservacoesTimesheet={openObservacoesTimesheet}
                                            openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                            openModalTimesheetTimeline={openModalTimesheetTimeline}
                                        ></TableAprovacoesPI>
                                    </StldRow>
                                    :
                                    <StldRow>
                                        <TableAprovacoes
                                            listaAprovacoes={ListaData}
                                            aprovacaoEmMassa={aprovacaoEmMassa}
                                            clearCheckedList={minhasAprovacoesPI}
                                            setAprovacaoEmMassaList={setAprovacaoEmMassaList}
                                            openModalAprovacaoEmMassa={openModalAprovacaoEmMassa}
                                            openModalAprovar={openModalAprovar}
                                            openModalReprovar={openModalReprovar}
                                            openModalCancelar={openModalCancelar}
                                            openModalTransferir={openModalTransferir}
                                            openModalConcluir={openModalConcluir}
                                            openHistoricoAprovacoesModal={openHistoricoAprovacoesModal}
                                            openObservacoesTimesheet={openObservacoesTimesheet}
                                            openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                            openModalTimesheetTimeline={openModalTimesheetTimeline}
                                        ></TableAprovacoes>
                                    </StldRow>
                                );
                            }
                            else {
                                return (
                                    <StldRow>
                                        {
                                            ListaData != null && ListaData?.data?.itens?.map((item, index) => {
                                                return (
                                                    <StldColumn key={index} xs="12" sm="6" md="4" lg="3" xl="3">
                                                        <CardPendenciaDeAprovacaoOptions
                                                            item={item}
                                                            getCardId={getCardId}
                                                            index={index}
                                                            openModalAprovar={openModalAprovar}
                                                            openModalReprovar={openModalReprovar}
                                                            openModalCancelar={openModalCancelar}
                                                            openModalTransferir={openModalTransferir}
                                                            openModalConcluir={openModalConcluir}
                                                            openHistoricoAprovacoesModal={openHistoricoAprovacoesModal}
                                                            openObservacoesTimesheet={openObservacoesTimesheet}
                                                            openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                                            openModalTimesheetTimeline={openModalTimesheetTimeline}
                                                        />
                                                    </StldColumn>
                                                )
                                            })
                                        }
                                        {
                                            ListaData?.data?.itens.length == 0 && <StldColumn xs="12" sm="12" md="12">
                                                <div className="alert alert-warning" role="alert">
                                                    Atenção! Nenhum resultado encontrado!
                                                </div>
                                            </StldColumn>
                                        }
                                    </StldRow>
                                )
                            }
                        })()}
                        {
                            (() => {
                                if (ListaData != null) {
                                    return (
                                        <PaginationCustom
                                            isMobile={isMobile}
                                            isDesktop={isDesktop}
                                            length={ListaData?.data?.page?.length ?? 0}
                                            recordsTotal={ListaData?.data?.page?.recordsTotal ?? 0}
                                            currentPage={currentPage ?? 0}
                                            formData={loadTable}
                                            pageSize={pageSize ?? 300}
                                            setPageSize={setPageSize}
                                            setPage={(page) => setCurrentPage(page)} />
                                    )
                                }
                                return null
                            })()
                        }
                    </div >
                    <br />
                    <ModalNotificacaoAprovacaoHistorico
                        isOpen={modalHistoricoAprovacoesIsOpen}
                        onRequestClose={closeNotifyHistoricoModal}
                        ariaHideApp={false}
                        pendenciaDeAprovacao={pendenciaDeAprovacao}
                    >
                    </ModalNotificacaoAprovacaoHistorico>

                    <ModalAprovacaoEmMassa
                        aprovacaoEmMassaList={aprovacaoEmMassaList}
                        isOpen={aprovacaoEmMassaOpemModal}
                        setIsOpen={closeModalAprovacaoEmMassa}
                        onRequestClose={closeModalAprovacaoEmMassa}
                        loadTable={loadTable}
                    ></ModalAprovacaoEmMassa>
                    <ModalAprovacoesAprovar
                        pendenciaDeAprovacao={pendenciaDeAprovacao}
                        isOpen={modalAprovarIsOpen}
                        setIsOpen={closeModalAprovar}
                        onRequestClose={closeModalAprovar}
                        loadTable={loadTable}
                    >
                    </ModalAprovacoesAprovar>
                    <ModalAprovacoesReprovar
                        pendenciaDeAprovacao={pendenciaDeAprovacao}
                        isOpen={modalReprovarIsOpen}
                        setIsOpen={closeModalReprovar}
                        onRequestClose={closeModalReprovar}
                        loadTable={loadTable}
                    >
                    </ModalAprovacoesReprovar>
                    <ModalAprovacoesCancelar
                        pendenciaDeAprovacao={pendenciaDeAprovacao}
                        isOpen={modalCancelarIsOpen}
                        setIsOpen={closeModalCancelar}
                        onRequestClose={closeModalCancelar}
                        loadTable={loadTable}
                    >
                    </ModalAprovacoesCancelar>
                    <ModalAprovacoesTransferir
                        usuarios={peritosList}
                        pendenciaDeAprovacao={pendenciaDeAprovacao}
                        isOpen={modalTransferirIsOpen}
                        setIsOpen={closeModalTransferir}
                        onRequestClose={closeModalTransferir}
                        loadTable={loadTable}
                        isFromProjetoInterno={minhasAprovacoesPI}
                    >
                    </ModalAprovacoesTransferir>
                    <ModalAprovacoesConcluir
                        pendenciaDeAprovacao={pendenciaDeAprovacao}
                        isOpen={modalConcluirIsOpen}
                        setIsOpen={closeModalConcluir}
                        onRequestClose={closeModalConcluir}
                        loadTable={loadTable}
                    >
                    </ModalAprovacoesConcluir>
                    <ModalObservacao
                        isOpen={modalObservacoes}
                        onAfterOpen={afterNotifyGrupoOpenModal}
                        onRequestClose={closeModalObservacoes}
                        idTimesheet={selectedIdTimesheet}
                    >
                    </ModalObservacao>
                    <ModalSolicitarEsclarecimento
                        pendenciaDeAprovacao={pendenciaDeAprovacao}
                        isOpen={modalSolicitarEsclarecimentoIsOpen}
                        setIsOpen={closeModalSolicitarEsclarecimento}
                        onRequestClose={closeModalSolicitarEsclarecimento}
                        loadTable={loadTable}
                        isFromProjetoInterno={minhasAprovacoesPI}
                    >
                    </ModalSolicitarEsclarecimento>
                    <ModalTimeline
                        isOpen={modalTimelineIsOpen}
                        setIsOpen={setmodalTimelineIsOpen}
                        onRequestClose={() => setmodalTimelineIsOpen(false)}
                        idTimesheet={selectedTimesheet?.idTimesheet}
                        timelineInfs={[
                            {
                                label: "Data do Sinistro",
                                value: selectedTimesheet?.dataSinistro || "Não informado"
                            },
                            {
                                label: "Data de abertura do Sinistro",
                                value: selectedTimesheet?.dataAbertura
                            },
                            {
                                label: "Data de abertura do TS",
                                value: selectedTimesheet?.dataTimesheet
                            }
                        ]}
                        porEtapaAprovacao={selectedTimesheet?.slaPorEtapa}
                        finalizacaoTS={selectedTimesheet?.dataFinalizacaoTS}
                        nomeEtapaAtual={selectedTimesheet?.nomeEtapa}
                        nfDataFaturamento={selectedTimesheet?.dataFaturamento}
                        nfDataRecebimento={selectedTimesheet?.dataRecebimento}
                    >
                    </ModalTimeline>
                </StyledDefaultPage >
            </main >
        </section >
    );
};

export const ListagemAprovacoesPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <Aprovacoes />
                </>
            )}
        </>
    );
};
